(function () {
  var BRAND = '#b54b11';
  var BRAND_TEXT = '#fffbf4';
  var TEXT = '#242424';
  var MUTED = '#808080';

  var VAR_MAP = {
    '--jm-review-widget-star-and-histogram-color': BRAND,
    '--jm-review-widget-button-color': BRAND,
    '--jm-review-widget-button-text-color': BRAND_TEXT,
    '--jm-review-widget-text-color': TEXT,
    '--jm-review-widget-lighter-text-color': MUTED,
    '--jm-widget-primary-color': BRAND,
    '--jm-review-widget-form-button-color': BRAND,
    '--jm-review-widget-form-button-text-color': BRAND_TEXT,
    '--jm-review-widget-form-text-color': TEXT,
    '--jm-review-widget-form-field-background-color': '#fffefd',
    '--jm-review-widget-form-background-color': '#ffffff',
    '--jm-review-widget-form-border-radius': '0px',
    '--jm-widget-border-radius': '0px',
    '--jm-widget-border-radius-simplified': '0px',
    '--jdgm-primary-color': BRAND,
    '--jdgm-secondary-color': BRAND,
    '--jdgm-star-color': BRAND,
    '--jdgm-write-review-bg-color': BRAND,
    '--jdgm-write-review-text-color': BRAND_TEXT,
    '--jdgm-paginate-color': BRAND,
    '--17d289b0': BRAND,
  };

  function applyVars(el) {
    if (!el || !el.style) return;
    Object.keys(VAR_MAP).forEach(function (key) {
      el.style.setProperty(key, VAR_MAP[key], 'important');
    });
  }

  function scrubTeal(el) {
    if (!el || !el.getAttribute) return;
    var style = el.getAttribute('style');
    if (!style) return;
    if (style.indexOf('108474') === -1 && style.indexOf('16, 132, 116') === -1) return;
    el.setAttribute(
      'style',
      style
        .replace(/#108474/gi, BRAND)
        .replace(/rgb\(\s*16\s*,\s*132\s*,\s*116\s*\)/gi, BRAND)
    );
  }

  function starRowHtml(score, total) {
    /* Figma: filled stars by floor(avg), remainder outlined */
    var filled = Math.max(0, Math.min(total, Math.floor(score)));
    var html = '';
    var i;
    for (i = 1; i <= total; i++) {
      html +=
        i <= filled
          ? '<span class="mandira-star mandira-star--on" aria-hidden="true">★</span>'
          : '<span class="mandira-star mandira-star--off" aria-hidden="true">★</span>';
    }
    return html;
  }

  function parseRating(text) {
    var m = String(text || '').match(/(\d+(?:\.\d+)?)/);
    return m ? parseFloat(m[1]) : null;
  }

  var userOpenedWriteReview = false;
  var writeFormLockUntil = 0;
  var writeOpenTimers = [];
  var reviewSubmitPending = false;
  var reviewSubmitCloseTimer = null;
  var reviewSubmitLocked = false;
  var writeFormOpenLock = false;
  var storePromptSkipDone = false;
  var pendingReviewDraft = null;
  var jmEmptyGraceUntil = Date.now() + 4000;

  function clearWriteOpenTimers() {
    writeOpenTimers.forEach(function (id) {
      window.clearTimeout(id);
    });
    writeOpenTimers = [];
  }

  function queueWriteOpenTimer(fn, ms) {
    writeOpenTimers.push(window.setTimeout(fn, ms));
  }

  function readSummaryFromDom(section) {
    var score = null;
    var count = null;

    var widget =
      section.querySelector('#judgeme_product_reviews') ||
      section.querySelector('.jdgm-review-widget') ||
      section.querySelector('.jm-review-widget');

    /* Count only owned unique rows — never hidden JM clones still in .product-reviews-app */
    var ownedList = section.querySelector('.mandira-reviews-list');
    var reviewRows = ownedList
      ? Array.prototype.filter.call(ownedList.children, function (el) {
          return (
            el.classList &&
            (el.classList.contains('jdgm-rev') ||
              el.classList.contains('jm-review-item') ||
              el.classList.contains('jm-align-review-item') ||
              el.classList.contains('mandira-review-card'))
          );
        })
      : Array.prototype.slice.call(
          section.querySelectorAll(
            '.jdgm-ssr-reviews__list > .jdgm-rev, .product-reviews-app .jdgm-rev, .product-reviews-app .jm-review-item',
          ),
        );
    var hasRows = reviewRows.length > 0;

    /* Prefer SSR star-distribution (product-accurate; ignores shop-level attrs) */
    var dist = section.querySelector('.jdgm-ssr-rating-distribution, .jdgm-histogram__row, .jm-histogram');
    if (dist) {
      var distTotal = 0;
      var distWeighted = 0;
      var distItems = dist.querySelectorAll('li, .jdgm-histogram__row, [class*="histogram"]');
      if (!distItems.length) distItems = [dist];
      Array.prototype.forEach.call(distItems, function (el) {
        var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
        var m = t.match(/(\d)\s*stars?:?\s*(\d+)/i);
        if (!m) m = t.match(/(\d+)\s*\(\s*(\d+(?:\.\d+)?)\s*%\s*\)/);
        if (m && /star/i.test(t)) {
          var stars = parseInt(m[1], 10);
          var n = parseInt(m[2], 10);
          if (stars >= 1 && stars <= 5 && n >= 0) {
            distTotal += n;
            distWeighted += stars * n;
          }
        }
      });
      if (distTotal > 0) {
        count = distTotal;
        score = distWeighted / distTotal;
      }
    }

    var avg =
      section.querySelector('.jm-average-rating-display') ||
      section.querySelector('.jdgm-rev-widg__summary') ||
      section.querySelector('.jdgm-histogram__average') ||
      section.querySelector('.jdgm-rev-widg__summary-average');

    if (avg && (score == null || count == null)) {
      var texts = Array.prototype.map
        .call(avg.querySelectorAll('.jm-text, .jdgm-rev-widg__summary-text, .jdgm-rev-widg__summary-average, span, p, div'), function (el) {
          return (el.textContent || '').trim();
        })
        .filter(Boolean);
      if (score == null) {
        var scoreText = texts.find(function (t) {
          return /^\d+(\.\d+)?(\s*\/\s*5)?$/.test(t);
        });
        score = parseRating(scoreText);
      }
      if (count == null) {
        var countText = texts.find(function (t) {
          return /review/i.test(t);
        });
        var countMatch = (countText || '').match(/(\d+)/);
        if (countMatch) count = parseInt(countMatch[1], 10);
      }
      avg.setAttribute('data-mandira-hidden', '1');
    }

    if (widget) {
      if (score == null) {
        /* Product attrs only — do NOT fall back to data-shop-* */
        score = parseRating(widget.getAttribute('data-average-rating'));
      }
      if (count == null) {
        var c =
          widget.getAttribute('data-number-of-reviews') ||
          widget.getAttribute('data-product-reviews-count');
        if (c != null && c !== '') count = parseInt(c, 10);
      }
    }

    if (score == null) score = parseRating(section.getAttribute('data-jm-rating'));
    if (count == null) {
      var attrCount = section.getAttribute('data-jm-count');
      if (attrCount != null && attrCount !== '') count = parseInt(attrCount, 10);
    }

    /* Owned unique rows are source of truth once harvested; distribution is a fallback only */
    if (hasRows && ownedList) {
      count = reviewRows.length;
    } else {
      var locked = section.getAttribute('data-mandira-review-count');
      if (locked != null && locked !== '') {
        var lockedN = parseInt(locked, 10);
        if (lockedN > 0) count = Math.max(count || 0, lockedN);
      }
      if (hasRows) count = Math.max(count || 0, reviewRows.length);
    }
    var lockedScore = section.getAttribute('data-mandira-review-score');
    if (lockedScore != null && lockedScore !== '' && score == null) {
      score = parseRating(lockedScore);
    }

    if (score == null && hasRows) {
      var sum = 0;
      var n = 0;
      reviewRows.forEach(function (row) {
        var ratingEl =
          row.querySelector('.jdgm-rev__rating, .jm-star-rating') || row;
        var rated =
          row.getAttribute('data-score') ||
          (ratingEl && ratingEl.getAttribute('data-score')) ||
          (ratingEl && ratingEl.getAttribute('aria-label'));
        var parsed = parseRating(rated);
        if (parsed != null) {
          sum += parsed;
          n += 1;
        }
      });
      if (n > 0) score = sum / n;
    }

    /* Judge.me often leaves data-empty-state=empty_widget even when SSR has reviews */
    if (!hasRows && !(count > 0)) {
      return {score: null, count: 0, empty: true};
    }

    if (count > 0 && widget && /empty/i.test(widget.getAttribute('data-empty-state') || '')) {
      widget.setAttribute('data-empty-state', 'with_reviews');
    }

    return {score: score, count: count, empty: false};
  }

  function reshapeSummary() {
    var section = document.querySelector('.product-reviews--judgeme');
    if (!section) return;

    var data = readSummaryFromDom(section);
    var score = data.score;
    var count = data.count;
    var summary = section.querySelector('.mandira-reviews-summary');
    var ownedCount = getReviewRows(section).length;
    if (ownedCount > (count || 0)) count = ownedCount;

    if (data.empty || score == null || !(count > 0)) {
      /* Never wipe a real summary just because Shopify metafield count is 0 */
      if (ownedCount > 0) {
        count = ownedCount;
        if (score == null) score = parseRating(section.getAttribute('data-mandira-review-score')) || 5;
      } else {
        if (summary && !summary.hasAttribute('data-mandira-summary-ssr')) {
          summary.remove();
        }
        return;
      }
    }

    var scoreLabel = score.toFixed(1) + '/5';
    var countLabel = count + (count === 1 ? ' Review' : ' Reviews');

    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'mandira-reviews-summary';
      var heading = section.querySelector('.product-reviews-heading');
      if (heading) heading.insertAdjacentElement('afterend', summary);
      else section.insertBefore(summary, section.firstChild);
    }

    var writeBtn = summary.querySelector('[data-mandira-write-review]');
    summary.innerHTML =
      '<div class="mandira-reviews-score" aria-label="' +
      score.toFixed(1) +
      ' out of 5 stars">' +
      '<span class="mandira-reviews-stars">' +
      starRowHtml(score, 5) +
      '</span>' +
      '<span class="mandira-reviews-score-value">' +
      scoreLabel +
      '</span>' +
      '</div>' +
      '<p class="mandira-reviews-count">' +
      countLabel +
      '</p>';

    /* Phone / empty: keep Write CTA. Desktop filled Figma omits it. */
    var hasRows = Boolean(
      section.querySelector('.jm-review-item, .jdgm-rev, .mandira-review-card'),
    );
    if (!(hasRows && isDesktopReviews())) {
      if (writeBtn) summary.appendChild(writeBtn);
      else {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mandira-write-review-btn';
        btn.setAttribute('data-mandira-write-review', '');
        btn.textContent = 'Write a Review';
        summary.appendChild(btn);
      }
    }
  }

  function stageJmWriteTargets() {
    var section = document.querySelector('.product-reviews--judgeme');
    if (!section) return;

    /* Temporarily restore Judge.me write controls so their handlers can run */
    section
      .querySelectorAll(
        '.jm-no-reviews-state, .jdgm-empty-state, .jdgm-rev-widg__header, .jm-action-buttons, .jm-review-widget-minimal-header__action-buttons, .jdgm-write-rev-link, [data-testid="write-review-button"], .jm-button--primary, a.jdgm-write-rev-link, button.jdgm-btn',
      )
      .forEach(function (el) {
        if (el.classList.contains('mandira-write-review-btn')) return;
        el.style.setProperty('display', 'block', 'important');
        el.style.setProperty('visibility', 'visible', 'important');
        el.style.setProperty('opacity', '0.01', 'important');
        el.style.setProperty('pointer-events', 'auto', 'important');
        el.style.setProperty('position', 'fixed', 'important');
        el.style.setProperty('left', '12px', 'important');
        el.style.setProperty('top', '12px', 'important');
        el.style.setProperty('z-index', '2147483645', 'important');
        el.removeAttribute('hidden');
      });
  }

  function findJudgeMeWriteButton() {
    stageJmWriteTargets();

    /* Prefer REAL Judge.me controls — never our Mandira CTA */
    var selectors = [
      '.product-reviews--judgeme [data-testid="write-review-button"]',
      '.product-reviews--judgeme .jm-no-reviews-state [data-testid="write-review-button"]',
      '.product-reviews--judgeme .jm-no-reviews-state .jm-button--primary',
      '.product-reviews--judgeme .jm-action-buttons .jm-button--primary',
      '.product-reviews--judgeme .jm-review-widget-minimal-header__action-buttons button',
      '.product-reviews--judgeme a.jdgm-write-rev-link:not(.mandira-jm-write-trigger)',
      '.product-reviews--judgeme .jdgm-write-rev-link:not(.mandira-jm-write-trigger)',
      'a.jdgm-write-rev-link:not(.mandira-jm-write-trigger)',
      '.jdgm-write-rev-link:not(.mandira-jm-write-trigger)',
      '.product-reviews--judgeme .jm-button--primary',
      'button.jdgm-btn.jdgm-btn--solid',
    ];
    var i;
    for (i = 0; i < selectors.length; i++) {
      var nodes = document.querySelectorAll(selectors[i]);
      var j;
      for (j = 0; j < nodes.length; j++) {
        var el = nodes[j];
        if (!el || el.classList.contains('mandira-write-review-btn')) continue;
        if (el.classList.contains('mandira-jm-write-trigger')) continue;
        var text = (el.textContent || '').trim().toLowerCase();
        if (
          el.getAttribute('data-testid') === 'write-review-button' ||
          el.classList.contains('jdgm-write-rev-link') ||
          el.classList.contains('jm-button--primary') ||
          text.indexOf('write') !== -1
        ) {
          return el;
        }
      }
    }
    return null;
  }

  function revealForClick(el) {
    if (!el) return null;
    var chain = [];
    var node = el;
    while (node && node !== document.body) {
      chain.push({
        el: node,
        style: node.getAttribute('style'),
        hidden: node.hasAttribute('hidden'),
      });
      node.style.setProperty('display', 'block', 'important');
      node.style.setProperty('visibility', 'visible', 'important');
      node.style.setProperty('opacity', '1', 'important');
      node.style.setProperty('pointer-events', 'auto', 'important');
      node.style.setProperty('max-height', 'none', 'important');
      node.removeAttribute('hidden');
      node = node.parentElement;
    }
    // Keep real button off-screen but activatable
    el.style.setProperty('position', 'fixed', 'important');
    el.style.setProperty('left', '0', 'important');
    el.style.setProperty('top', '0', 'important');
    el.style.setProperty('z-index', '2147483646', 'important');
    el.style.setProperty('opacity', '0.01', 'important');
    return chain;
  }

  function restoreAfterClick(chain) {
    if (!chain) return;
    chain.forEach(function (item) {
      if (item.style == null || item.style === '') item.el.removeAttribute('style');
      else item.el.setAttribute('style', item.style);
      if (item.hidden) item.el.setAttribute('hidden', '');
    });
  }

  function markWriteModalOpen() {
    if (!userOpenedWriteReview) return;
    configureWriteReviewFormSettings();
    document.querySelectorAll('.jdgm-write-review-modal, .jdgm-review-widget-modal').forEach(function (modal) {
      modal.setAttribute('data-mandira-write-open', 'true');
      modal.removeAttribute('hidden');
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.remove('jdgm--hidden');
      modal.classList.add('jdgm--visible');
      modal.style.setProperty('display', 'flex', 'important');
      modal.style.setProperty('visibility', 'visible', 'important');
      modal.style.setProperty('opacity', '1', 'important');
      modal.style.setProperty('pointer-events', 'auto', 'important');
      modal.style.setProperty('z-index', '2147483000', 'important');
    });
    hideUnwantedWriteFormSteps();
  }

  function ensureWriteModalClosed() {
    clearWriteOpenTimers();
    userOpenedWriteReview = false;
    writeFormLockUntil = 0;
    document.querySelectorAll('.jdgm-write-review-modal, .jdgm-review-widget-modal').forEach(function (modal) {
      modal.removeAttribute('data-mandira-write-open');
      modal.setAttribute('hidden', '');
      modal.setAttribute('aria-hidden', 'true');
      modal.classList.remove('jdgm--visible', 'is-open', 'jdgm-write-review-modal--open');
      modal.classList.add('jdgm--hidden');
      modal.style.setProperty('display', 'none', 'important');
      modal.style.setProperty('visibility', 'hidden', 'important');
      modal.style.setProperty('opacity', '0', 'important');
      modal.style.setProperty('pointer-events', 'none', 'important');
    });
    document.body.style.removeProperty('overflow');
    document.documentElement.style.removeProperty('overflow');
  }

  function isWriteFormOpen() {
    return Boolean(
      document.querySelector(
        '.jdgm-write-review-modal[data-mandira-write-open="true"], .jdgm-review-widget-modal[data-mandira-write-open="true"]',
      ),
    );
  }

  function openHostedWriteForm() {
    if (!userOpenedWriteReview) return;
    var widget = document.querySelector('#judgeme_product_reviews, .jdgm-review-widget');
    var productId =
      (widget && (widget.getAttribute('data-id') || widget.getAttribute('data-product-id'))) ||
      '';
    var shop = (window.Shopify && window.Shopify.shop) || '3qeeyt-qr.myshopify.com';
    if (!productId) return;
    var url =
      'https://judge.me/reviews/new?shop_domain=' +
      encodeURIComponent(shop) +
      '&platform=shopify&id=' +
      encodeURIComponent(productId);
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  function openWriteReviewForm() {
    /* Prevent double-open (API + button) which causes Judge.me to post twice */
    if (writeFormOpenLock || isWriteFormOpen()) {
      markWriteModalOpen();
      return true;
    }
    writeFormOpenLock = true;
    window.setTimeout(function () {
      writeFormOpenLock = false;
    }, 2000);

    clearWriteOpenTimers();
    userOpenedWriteReview = true;
    reviewSubmitLocked = false;
    reviewSubmitPending = false;
    storePromptSkipDone = false;
    pendingReviewDraft = null;
    writeFormLockUntil = Date.now() + 12000;
    configureWriteReviewFormSettings();
    stageJmWriteTargets();

    var opened = false;
    var clickedJm = false;
    var jmBtn = findJudgeMeWriteButton();
    var chain = null;

    /* Prefer a single real Judge.me control click — never API + click together */
    if (jmBtn) {
      chain = revealForClick(jmBtn);
      try {
        if (typeof jmBtn.click === 'function') jmBtn.click();
        opened = true;
        clickedJm = true;
      } catch (e2) {
        /* ignore */
      }
    }

    if (!clickedJm) {
      try {
        if (window.jdgm && typeof window.jdgm.openReviewForm === 'function') {
          window.jdgm.openReviewForm();
          opened = true;
        } else if (
          window.jdgm &&
          window.jdgm.customize &&
          typeof window.jdgm.customize.openReviewForm === 'function'
        ) {
          window.jdgm.customize.openReviewForm();
          opened = true;
        }
      } catch (e) {
        /* ignore */
      }
    }

    /* Mark open only after JM has had a chance to mount the modal */
    queueWriteOpenTimer(markWriteModalOpen, 80);
    queueWriteOpenTimer(markWriteModalOpen, 300);
    queueWriteOpenTimer(markWriteModalOpen, 800);

    queueWriteOpenTimer(function () {
      if (chain) restoreAfterClick(chain);
      if (!userOpenedWriteReview) return;
      if (isWriteFormOpen()) {
        markWriteModalOpen();
        return;
      }
      if (opened || clickedJm) {
        queueWriteOpenTimer(function () {
          if (!userOpenedWriteReview) return;
          if (isWriteFormOpen()) {
            markWriteModalOpen();
            return;
          }
          openHostedWriteForm();
        }, 1500);
        return;
      }
      openHostedWriteForm();
    }, 1600);

    return opened;
  }

  function ensureWriteReviewButton() {
    var section = document.querySelector('.product-reviews--judgeme');
    if (!section) return;

    var hasReviews = Boolean(
      section.querySelector('.jm-review-item, .jdgm-rev, .mandira-review-card'),
    );
    var summary = section.querySelector('.mandira-reviews-summary');
    var btn = summary && summary.querySelector('[data-mandira-write-review]');

    /* Figma desktop filled state: stars + avg + count only — no Write CTA */
    if (hasReviews && isDesktopReviews()) {
      if (btn) btn.remove();
      return;
    }

    if (!hasReviews) {
      /* Keep Write CTA inside Figma empty state; only strip stray orphans */
      section.querySelectorAll('.mandira-write-review-btn').forEach(function (orphan) {
        if (orphan.closest('.mandira-reviews-empty')) return;
        if (orphan.closest('.mandira-reviews-summary')) return;
        orphan.remove();
      });
      return;
    }

    if (!summary) return;

    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mandira-write-review-btn';
      btn.setAttribute('data-mandira-write-review', '');
      btn.textContent = 'Write a Review';
      summary.appendChild(btn);
    }
  }

  function isDesktopReviews() {
    return window.matchMedia('(min-width: 900px)').matches;
  }

  function hideReviewChrome() {
    var desktop = isDesktopReviews();
    var hideSel = desktop
      ? '.product-reviews--judgeme .jm-filters, .product-reviews--judgeme .jm-reviewer-avatar, .product-reviews--judgeme .jm-average-rating-display[data-mandira-hidden="1"], .product-reviews--judgeme .jm-review-widget-minimal-header__title'
      : '.product-reviews--judgeme .jm-review-widget-minimal-header__filter-container, .product-reviews--judgeme .jm-filters, .product-reviews--judgeme .jm-sort-filter, .product-reviews--judgeme .jdgm-sort-dropdown-wrapper, .product-reviews--judgeme .jm-reviewer-avatar, .product-reviews--judgeme .jm-average-rating-display[data-mandira-hidden="1"], .product-reviews--judgeme .jm-review-widget-minimal-header__title';

    document.querySelectorAll(hideSel).forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
    });

    // Hide date lines inside reviewer details (e.g. 09/11/2026)
    document
      .querySelectorAll('.product-reviews--judgeme .jm-reviewer-info__details .jm-text')
      .forEach(function (el) {
        var t = (el.textContent || '').trim();
        if (/^\d{1,2}[\/\-]\d{1,2}[\/\-]\d{2,4}$/.test(t) || /ago|yesterday|today/i.test(t)) {
          el.style.setProperty('display', 'none', 'important');
          if (el.parentElement) el.parentElement.style.setProperty('display', 'none', 'important');
        }
      });
  }

  function forceStarSizes() {
    var desktop = isDesktopReviews();
    var size = desktop ? '25.25px' : '9.82px';
    var gap = desktop ? '4.21px' : '1.64px';

    document
      .querySelectorAll(
        '.product-reviews--judgeme .jm-star-rating__font-icon, .product-reviews--judgeme .jm-star-rating .jdgm-icon, .product-reviews--judgeme .jm-star-rating svg'
      )
      .forEach(function (el) {
        el.style.setProperty('font-size', size, 'important');
        el.style.setProperty('line-height', size, 'important');
        el.style.setProperty('width', size, 'important');
        el.style.setProperty('height', size, 'important');
        el.style.setProperty('color', BRAND, 'important');
      });

    document
      .querySelectorAll('.product-reviews--judgeme .jm-star-rating .jm-cluster')
      .forEach(function (el) {
        el.style.setProperty('gap', gap, 'important');
        el.style.setProperty('--cluster-space', gap, 'important');
      });
  }

  function reshapeReviewItems() {
    var section = document.querySelector('.product-reviews--judgeme');
    if (section) ensureMandiraReviewList(section);

    var roots = document.querySelectorAll(
      '.product-reviews--judgeme .mandira-reviews-list > .jdgm-rev, .product-reviews--judgeme .jm-review-item__content, .product-reviews--judgeme .jm-align-review-item__content, .product-reviews--judgeme .jdgm-rev',
    );

    roots.forEach(function (content) {
      if (!content) return;

      var isClassic = content.classList.contains('jdgm-rev');
      var nameEl =
        content.querySelector('.jm-reviewer-info__name') ||
        content.querySelector('.jdgm-rev__author');
      var stars =
        content.querySelector('.jm-star-rating') || content.querySelector('.jdgm-rev__rating');
      var body =
        content.querySelector('.jm-review-content') ||
        content.querySelector('.jm-review-content__body') ||
        content.querySelector('.jdgm-rev__body');

      if (!stars && !nameEl && !body) return;

      var desktop = isDesktopReviews();
      var cardGap = desktop ? '51.5px' : '20.06px';
      var bodySize = desktop ? '27.357px' : '10.6424px';
      var metaGap = desktop ? '5.26px' : '2.05px';
      var nameSize = desktop ? '25.2526px' : '9.82px';

      /* Figma Frame 220: name → stars → body as only visible children */
      var meta = content.querySelector(':scope > .mandira-review-meta');
      if (!meta) {
        meta = document.createElement('div');
        meta.className = 'mandira-review-meta';
      }

      var nameOnly = meta.querySelector('.mandira-review-name');
      if (!nameOnly) {
        nameOnly = document.createElement('div');
        nameOnly.className = 'mandira-review-name';
        meta.appendChild(nameOnly);
      }
      if (nameEl) {
        var nameText = (nameEl.textContent || '').trim();
        if (nameText) nameOnly.textContent = nameText;
      }

      if (stars && stars.parentElement !== meta) meta.appendChild(stars);
      if (nameOnly.parentElement !== meta) meta.insertBefore(nameOnly, meta.firstChild);

      content.insertBefore(meta, content.firstChild);
      if (body) content.appendChild(body);

      Array.prototype.forEach.call(Array.prototype.slice.call(content.children), function (child) {
        if (child === meta || child === body) return;
        child.style.setProperty('display', 'none', 'important');
        child.setAttribute('aria-hidden', 'true');
      });

      content.classList.add('mandira-review-card');
      content.dataset.mandiraShaped = '1';

      content.style.setProperty('display', 'flex', 'important');
      content.style.setProperty('flex-direction', 'column', 'important');
      content.style.setProperty('align-items', 'flex-start', 'important');
      content.style.setProperty('gap', cardGap, 'important');
      content.style.setProperty('row-gap', cardGap, 'important');

      meta.style.setProperty('display', 'flex', 'important');
      meta.style.setProperty('flex-direction', 'column', 'important');
      meta.style.setProperty('align-items', 'flex-start', 'important');
      meta.style.setProperty('gap', metaGap, 'important');
      meta.style.setProperty('order', '1', 'important');

      nameOnly.style.setProperty('display', 'block', 'important');
      nameOnly.style.setProperty('font-size', nameSize, 'important');
      nameOnly.style.setProperty('line-height', '110%', 'important');
      nameOnly.style.setProperty('font-weight', '500', 'important');
      nameOnly.style.setProperty('color', TEXT, 'important');
      nameOnly.style.setProperty('margin', '0', 'important');

      if (stars) {
        stars.style.setProperty('display', 'flex', 'important');
        stars.style.setProperty('align-items', 'center', 'important');
        stars.style.setProperty('gap', desktop ? '4.21px' : '1.64px', 'important');
        stars.style.setProperty('order', '2', 'important');
        stars.style.setProperty('margin', '0', 'important');
      }

      if (body) {
        body.style.setProperty('display', 'block', 'important');
        body.style.setProperty('order', '2', 'important');
        body.style.setProperty('margin', '0', 'important');
        body.style.setProperty('font-size', bodySize, 'important');
        body.style.setProperty('line-height', '110%', 'important');
        body.style.setProperty('font-weight', '500', 'important');
        body.style.setProperty('color', MUTED, 'important');
        body.querySelectorAll('p, .jm-text').forEach(function (el) {
          el.style.setProperty('font-size', bodySize, 'important');
          el.style.setProperty('line-height', '110%', 'important');
          el.style.setProperty('font-weight', '500', 'important');
          el.style.setProperty('color', MUTED, 'important');
          el.style.setProperty('margin', '0', 'important');
        });
      }

      if (!isClassic) {
        var item = content.closest('.jm-review-item, .jm-align-review-item');
        if (item) {
          item.querySelectorAll('.jm-stack').forEach(function (stack) {
            if (
              stack.classList.contains('mandira-review-card') ||
              stack.classList.contains('jm-review-item__content')
            ) {
              stack.style.setProperty('gap', cardGap, 'important');
              return;
            }
            stack.style.setProperty('gap', '0px', 'important');
          });
        }
      }
    });
  }

  var REVIEW_PAGE_SIZE = 5;

  function reviewIdOf(rev) {
    if (!rev || !rev.getAttribute) return '';
    return (
      rev.getAttribute('data-review-id') ||
      rev.getAttribute('data-review-uuid') ||
      ''
    );
  }

  function reviewContentKey(rev) {
    if (!rev) return '';
    var name = (
      (
        rev.querySelector('.jdgm-rev__author, .jm-reviewer-info__name, .mandira-review-name') ||
        {}
      ).textContent || ''
    )
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
    var body = (
      (
        rev.querySelector('.jdgm-rev__body, .jm-review-content, .jm-review-content__body') ||
        {}
      ).textContent || ''
    )
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
    if (!name && !body) return '';
    return name + '|' + body;
  }

  function reviewFingerprint(rev) {
    if (!rev) return '';
    var id = reviewIdOf(rev);
    if (id) return 'id:' + id;
    var content = reviewContentKey(rev);
    if (!content) return '';
    return 'fp:' + content;
  }

  function isOptimisticReview(rev) {
    return Boolean(
      rev &&
        (rev.getAttribute('data-mandira-optimistic') === '1' ||
          (rev.classList && rev.classList.contains('mandira-review-optimistic'))),
    );
  }

  function isReviewRow(el) {
    if (!el || !el.classList) return false;
    return (
      el.classList.contains('jdgm-rev') ||
      el.classList.contains('jm-review-item') ||
      el.classList.contains('jm-align-review-item') ||
      el.classList.contains('mandira-review-card')
    );
  }

  function removeNode(row) {
    try {
      row.remove();
    } catch (e) {
      row.style.setProperty('display', 'none', 'important');
    }
  }

  function dedupeOwnedReviewList(list) {
    if (!list) return 0;
    var byId = {};
    var byContent = {};
    var kept = 0;

    Array.prototype.slice.call(list.children).forEach(function (row) {
      if (!isReviewRow(row)) return;

      var id = reviewIdOf(row);
      var content = reviewContentKey(row);
      var optimistic = isOptimisticReview(row);

      /* Drop optimistic cards once the real Judge.me review arrives */
      if (optimistic && content && byContent[content] && !isOptimisticReview(byContent[content])) {
        removeNode(row);
        return;
      }
      if (!optimistic && content && byContent[content] && isOptimisticReview(byContent[content])) {
        removeNode(byContent[content]);
        delete byContent[content];
        kept = Math.max(0, kept - 1);
      }

      if (id && byId[id]) {
        /* Prefer non-optimistic / already-shaped card */
        if (optimistic) {
          removeNode(row);
          return;
        }
        removeNode(byId[id]);
        kept = Math.max(0, kept - 1);
      }
      if (content && byContent[content] && byContent[content] !== row) {
        if (optimistic) {
          removeNode(row);
          return;
        }
        if (isOptimisticReview(byContent[content]) || !reviewIdOf(byContent[content])) {
          removeNode(byContent[content]);
          kept = Math.max(0, kept - 1);
        } else {
          removeNode(row);
          return;
        }
      }

      if (id) byId[id] = row;
      if (content) byContent[content] = row;
      kept += 1;
    });
    return kept;
  }

  function syncReviewCountFromList(section, list) {
    if (!section || !list) return;
    var rows = Array.prototype.filter.call(list.children, isReviewRow);
    var n = rows.length;
    section.setAttribute('data-mandira-review-count', String(n));
    var countEl = section.querySelector('.mandira-reviews-count');
    if (countEl && n > 0) {
      countEl.textContent = n + (n === 1 ? ' Review' : ' Reviews');
    }
    if (n > 0) {
      section.classList.remove('product-reviews--empty');
      var empty = section.querySelector('.mandira-reviews-empty');
      if (empty) empty.remove();
    }
  }

  function ensureMandiraReviewList(section) {
    if (!section) return null;

    var list = section.querySelector(':scope > .mandira-reviews-list');
    if (!list) {
      list = document.createElement('div');
      list.className = 'mandira-reviews-list';
      var sort = section.querySelector('.mandira-reviews-sort-bar');
      var app = section.querySelector('.product-reviews-app');
      var summary = section.querySelector('.mandira-reviews-summary');
      if (sort) sort.insertAdjacentElement('afterend', list);
      else if (summary) summary.insertAdjacentElement('afterend', list);
      else if (app) app.insertAdjacentElement('beforebegin', list);
      else section.appendChild(list);
    }

    /* Index what we already own so JM hydrate clones are not appended again */
    var ownedKeys = {};
    Array.prototype.forEach.call(list.children, function (row) {
      var key = reviewFingerprint(row);
      if (key) ownedKeys[key] = true;
    });

    /* Move Judge.me rows into our owned list so hydrate cannot wipe hidden ones */
    var harvested = section.querySelectorAll(
      '.product-reviews-app .jdgm-rev, #judgeme_product_reviews .jdgm-rev, .jdgm-ssr-reviews__list .jdgm-rev, .product-reviews-app .jm-review-item, .product-reviews-app .jm-align-review-item',
    );
    Array.prototype.forEach.call(harvested, function (rev) {
      if (rev.closest('.mandira-reviews-list')) return;
      if (rev.closest('.jdgm-rev__reply')) return;
      /* Skip inner nodes when a parent review card is the harvest target */
      if (rev.closest('.jm-review-item, .jm-align-review-item, .jdgm-rev') !== rev) {
        if (rev.classList.contains('jdgm-rev') && rev.closest('.jm-review-item, .jm-align-review-item')) {
          return;
        }
      }
      var key = reviewFingerprint(rev);
      if (key && ownedKeys[key]) {
        try {
          rev.remove();
        } catch (e) {
          rev.style.setProperty('display', 'none', 'important');
        }
        return;
      }
      list.appendChild(rev);
      if (key) ownedKeys[key] = true;
    });

    dedupeOwnedReviewList(list);
    syncReviewCountFromList(section, list);

    /* Hide native JM review lists (we render ours) */
    section
      .querySelectorAll(
        '.product-reviews-app .jdgm-ssr-reviews, .product-reviews-app .jdgm-rev-widg__body, .product-reviews-app .jm-reviews-list, .product-reviews-app .jdgm-rev-widg__reviews',
      )
      .forEach(function (el) {
        if (el.closest('.mandira-reviews-list')) return;
        el.style.setProperty('display', 'none', 'important');
      });

    return list;
  }

  function getReviewRows(section) {
    ensureMandiraReviewList(section);
    var list = section.querySelector('.mandira-reviews-list');
    if (!list) return [];
    return Array.prototype.filter.call(list.children, isReviewRow);
  }

  function getTotalReviewCount(section) {
    return getReviewRows(section).length;
  }

  function findJmNextPage(section) {
    return (
      section.querySelector('.jdgm-paginate__next:not(.jdgm-curtained)') ||
      section.querySelector('.jdgm-paginate a[rel="next"]') ||
      section.querySelector('.jm-pagination-controls a[aria-label*="next" i]') ||
      null
    );
  }

  function canShowMoreReviews(section, shown, rows) {
    if (shown < rows.length) return true;
    if (findJmNextPage(section)) return true;
    var declared = parseInt(section.getAttribute('data-jm-count') || '0', 10);
    return declared > rows.length;
  }

  function applyClientPagination(section) {
    if (!section) return;
    var rows = getReviewRows(section);
    if (!rows.length) return;

    var shown = parseInt(section.getAttribute('data-mandira-shown') || '', 10);
    if (!(shown > 0)) {
      shown = Math.min(REVIEW_PAGE_SIZE, rows.length);
      section.setAttribute('data-mandira-shown', String(shown));
    }

    rows.forEach(function (row, i) {
      if (i < shown) {
        row.style.setProperty('display', 'flex', 'important');
        row.removeAttribute('hidden');
        row.removeAttribute('aria-hidden');
        row.classList.remove('mandira-review-hidden');
      } else {
        row.style.setProperty('display', 'none', 'important');
        row.classList.add('mandira-review-hidden');
      }
    });

    var link = section.querySelector('.mandira-view-more');
    var paginate = section.querySelector(':scope > .mandira-paginate');
    var canShowMore = canShowMoreReviews(section, shown, rows);
    if (paginate) {
      paginate.hidden = !canShowMore;
      paginate.style.setProperty('display', canShowMore ? 'flex' : 'none', 'important');
    }
    if (link) {
      link.hidden = !canShowMore;
      link.style.setProperty('display', canShowMore ? 'inline' : 'none', 'important');
    }
  }

  function revealMoreReviews(section) {
    ensureMandiraReviewList(section);
    var rows = getReviewRows(section);
    var current = parseInt(section.getAttribute('data-mandira-shown') || REVIEW_PAGE_SIZE, 10);
    var nextShown = Math.min(current + REVIEW_PAGE_SIZE, rows.length);

    /* If we still need rows Judge.me hasn't given us yet, pull next page then harvest */
    if (nextShown <= current || (current >= rows.length && findJmNextPage(section))) {
      var jmNext = findJmNextPage(section);
      if (jmNext) {
        var beforeIds = {};
        rows.forEach(function (r) {
          var id = r.getAttribute('data-review-id');
          if (id) beforeIds[id] = true;
        });
        var chain = revealForClick(jmNext);
        try {
          jmNext.style.setProperty('pointer-events', 'auto', 'important');
          jmNext.click();
        } catch (err) {
          /* ignore */
        }
        window.setTimeout(function () {
          restoreAfterClick(chain);
          ensureMandiraReviewList(section);
          var after = getReviewRows(section);
          /* Append-only: keep existing order, newly harvested already moved into list */
          var grown = after.length > rows.length;
          nextShown = Math.min(
            current + REVIEW_PAGE_SIZE,
            Math.max(after.length, current + (grown ? REVIEW_PAGE_SIZE : 0)),
          );
          if (nextShown <= current) nextShown = Math.min(current + REVIEW_PAGE_SIZE, after.length);
          section.setAttribute('data-mandira-shown', String(Math.max(nextShown, current + 1)));
          applyClientPagination(section);
          reshapeReviewItems();
        }, 600);
        /* Optimistically reveal whatever we already have */
        nextShown = Math.min(current + REVIEW_PAGE_SIZE, Math.max(rows.length, current + REVIEW_PAGE_SIZE));
      }
    }

    section.setAttribute('data-mandira-shown', String(nextShown));
    applyClientPagination(section);
    reshapeReviewItems();
  }

  function restylePagination() {
    var section = document.querySelector('.product-reviews--judgeme');
    if (!section) return;

    ensureMandiraReviewList(section);
    var rows = getReviewRows(section);
    if (!rows.length) return;

    var paginate = section.querySelector(':scope > .mandira-paginate');
    if (!paginate) {
      paginate = document.createElement('div');
      paginate.className = 'mandira-paginate';
      section.appendChild(paginate);
    }

    paginate.style.setProperty('justify-content', 'flex-end', 'important');
    paginate.style.setProperty('width', '100%', 'important');
    paginate.style.setProperty(
      'margin',
      isDesktopReviews() ? '28px 0 0' : '16px 0 0',
      'important',
    );

    section.querySelectorAll('.jdgm-paginate, .jm-pagination-controls').forEach(function (native) {
      if (native.classList.contains('mandira-paginate')) return;
      native.style.setProperty('position', 'absolute', 'important');
      native.style.setProperty('left', '-9999px', 'important');
      native.style.setProperty('width', '1px', 'important');
      native.style.setProperty('height', '1px', 'important');
      native.style.setProperty('opacity', '0', 'important');
      native.style.setProperty('overflow', 'hidden', 'important');
    });

    var link = paginate.querySelector('.mandira-view-more');
    if (!link) {
      link = document.createElement('button');
      link.type = 'button';
      link.className = 'mandira-view-more';
      paginate.appendChild(link);
    }
    link.type = 'button';
    link.textContent = 'View More';
    if (!link.getAttribute('data-mandira-bound')) {
      link.setAttribute('data-mandira-bound', '1');
      link.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        revealMoreReviews(section);
      });
    }

    if (!section.getAttribute('data-mandira-shown')) {
      section.setAttribute('data-mandira-shown', String(Math.min(REVIEW_PAGE_SIZE, rows.length)));
    }
    applyClientPagination(section);
  }

  function hideNativeFilledChrome() {
    var section = document.querySelector('.product-reviews--judgeme');
    if (!section || !section.querySelector('.mandira-reviews-summary')) return;

    var hide = [
      '.jdgm-rev-widg__summary',
      '.jdgm-rev-widg__header',
      '.jdgm-histogram',
      '.jm-histogram',
      '.jm-average-rating-display',
      '.jdgm-ssr-ai-content',
      '.jdgm-ssr-rating-distribution',
      '.jdgm-write-rev-link',
      '[data-testid="write-review-button"]',
      '.jm-review-widget-minimal-header__action-buttons',
      '.jm-action-buttons',
      '.jm-button--primary',
    ];
    if (isDesktopReviews()) {
      hide.forEach(function (sel) {
        section.querySelectorAll(sel).forEach(function (el) {
          if (el.closest('.mandira-reviews-summary')) return;
          if (el.classList.contains('mandira-jm-write-trigger')) return;
          if (el.getAttribute('data-mandira-jm-trigger') != null) return;
          el.style.setProperty('display', 'none', 'important');
        });
      });
    }
  }

  function reviewScore(row) {
    var el = row.querySelector('.jdgm-rev__rating, .jm-star-rating');
    return parseRating(
      (el && (el.getAttribute('data-score') || el.getAttribute('aria-label'))) ||
        row.getAttribute('data-score'),
    ) || 0;
  }

  function reviewTime(row) {
    var t = row.querySelector('.jdgm-rev__timestamp, time');
    var raw =
      (t && (t.getAttribute('datetime') || t.getAttribute('data-content'))) ||
      row.getAttribute('data-created-at') ||
      '';
    var ms = Date.parse(raw);
    return isNaN(ms) ? 0 : ms;
  }

  function reviewHasMedia(row) {
    return Boolean(
      row.querySelector(
        '.jdgm-rev__pics img, .jdgm-rev__vids, .jm-review-media, [class*="review-photo"]',
      ),
    );
  }

  function sortReviewRows(section, mode, keepShown) {
    if (!section || !mode) return;
    section.setAttribute('data-mandira-sort', mode);

    var list = ensureMandiraReviewList(section);
    var rows = getReviewRows(section);
    if (rows.length < 2) return;

    if (!list) list = rows[0].parentElement;
    if (!list) return;

    rows.sort(function (a, b) {
      if (mode === 'rating_desc') return reviewScore(b) - reviewScore(a);
      if (mode === 'rating_asc') return reviewScore(a) - reviewScore(b);
      if (mode === 'with_media') {
        var dm = (reviewHasMedia(b) ? 1 : 0) - (reviewHasMedia(a) ? 1 : 0);
        if (dm) return dm;
        return reviewTime(b) - reviewTime(a);
      }
      var tb = reviewTime(b);
      var ta = reviewTime(a);
      if (tb || ta) return tb - ta;
      /* fallback when timestamps missing: stable rating then DOM order */
      return reviewScore(b) - reviewScore(a);
    });

    rows.forEach(function (row) {
      list.appendChild(row);
    });

    if (!keepShown) {
      section.setAttribute(
        'data-mandira-shown',
        String(Math.min(REVIEW_PAGE_SIZE, rows.length)),
      );
    }
    applyClientPagination(section);
    reshapeReviewItems();
  }

  /** Figma desktop Sort — always above the list (Frame 223) */
  function ensureDesktopSort() {
    var section = document.querySelector('.product-reviews--judgeme');
    if (!section) return;

    var existing = section.querySelector('.mandira-reviews-sort-bar');
    if (!isDesktopReviews()) {
      if (existing) existing.remove();
      return;
    }

    var hasReviews = Boolean(
      section.querySelector('.jm-review-item, .jdgm-rev, .mandira-review-card'),
    );
    if (!hasReviews) {
      if (existing) existing.remove();
      return;
    }

    var bar = existing;
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'mandira-reviews-sort-bar';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mandira-reviews-sort';
      btn.setAttribute('aria-label', 'Sort reviews');
      btn.setAttribute('aria-haspopup', 'listbox');
      btn.innerHTML = 'Sort<span class="mandira-reviews-sort-chevron" aria-hidden="true"></span>';
      bar.appendChild(btn);

      var menu = document.createElement('div');
      menu.className = 'mandira-reviews-sort-menu';
      menu.hidden = true;
      [
        {label: 'Most recent', value: 'created_at'},
        {label: 'Highest rating', value: 'rating_desc'},
        {label: 'Lowest rating', value: 'rating_asc'},
        {label: 'With pictures', value: 'with_media'},
      ].forEach(function (opt) {
        var item = document.createElement('button');
        item.type = 'button';
        item.className = 'mandira-reviews-sort-option';
        item.textContent = opt.label;
        item.dataset.sort = opt.value;
        menu.appendChild(item);
      });
      bar.appendChild(menu);

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        menu.hidden = !menu.hidden;
      });

      menu.addEventListener('click', function (e) {
        var opt = e.target && e.target.closest && e.target.closest('.mandira-reviews-sort-option');
        if (!opt) return;
        e.preventDefault();
        e.stopPropagation();
        menu.hidden = true;
        Array.prototype.forEach.call(menu.querySelectorAll('.mandira-reviews-sort-option'), function (o) {
          o.classList.toggle('is-active', o === opt);
        });
        sortReviewRows(section, opt.dataset.sort, false);
      });

      document.addEventListener('click', function (e) {
        if (!bar.contains(e.target)) menu.hidden = true;
      });
    }

    var summary = section.querySelector('.mandira-reviews-summary');
    var app = section.querySelector('.product-reviews-app');
    if (summary && summary.nextElementSibling !== bar) {
      summary.insertAdjacentElement('afterend', bar);
    } else if (!summary && app && app.previousElementSibling !== bar) {
      app.insertAdjacentElement('beforebegin', bar);
    } else if (!summary && !app && bar.parentElement !== section) {
      section.appendChild(bar);
    }

    /* Default to newest-first so freshly published reviews appear at the top */
    if (!section.getAttribute('data-mandira-sort')) {
      var recentOpt = bar.querySelector('.mandira-reviews-sort-option[data-sort="created_at"]');
      if (recentOpt) recentOpt.classList.add('is-active');
      sortReviewRows(section, 'created_at', true);
    }
  }

  function hideNoise() {
    document.querySelectorAll('.jdgm-empty-state, .jdgm-empty-state .jm-text').forEach(function (el) {
      var t = (el.textContent || '').trim().toLowerCase();
      if (t === 'no items found' || t.indexOf('no items') === 0) {
        el.style.setProperty('display', 'none', 'important');
      }
    });
  }

  function capturePendingReviewDraft(modal) {
    if (!modal) modal = getOpenWriteModal();
    if (!modal) return pendingReviewDraft;

    var nameInput =
      modal.querySelector(
        'input[name*="name" i], input[name*="display" i], input[autocomplete="name"], input[placeholder*="name" i], input[type="text"]',
      ) || null;
    var bodyInput =
      modal.querySelector('textarea, textarea[name*="body" i], textarea[name*="review" i]') || null;
    var ratingGroup = modal.querySelector(
      '[class*="stars"], .jdgm-write-review-modal__stars, [role="radiogroup"]',
    );
    var score = (pendingReviewDraft && pendingReviewDraft.score) || 5;
    if (ratingGroup) {
      var ons = ratingGroup.querySelectorAll(
        '.jdgm-star.jdgm--on, .jm-star.jdgm--on, [class*="star"].jdgm--on, [aria-checked="true"]',
      );
      if (ons.length) score = ons.length;
    }
    var name = nameInput ? (nameInput.value || '').trim() : '';
    var body = bodyInput ? (bodyInput.value || '').trim() : '';

    /* Merge with previously typed values — JM multi-step clears fields on the thanks screen */
    var prev = pendingReviewDraft || {};
    name = name || prev.name || '';
    body = body || prev.body || '';
    if (!name && !body) return pendingReviewDraft;
    pendingReviewDraft = {name: name || 'Customer', body: body || '', score: score};
    try {
      sessionStorage.setItem('mandira_pending_review', JSON.stringify(pendingReviewDraft));
    } catch (e) {
      /* ignore */
    }
    return pendingReviewDraft;
  }

  function bindReviewDraftCapture() {
    if (bindReviewDraftCapture._bound) return;
    bindReviewDraftCapture._bound = true;
    document.addEventListener(
      'input',
      function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        if (!t.closest('.jdgm-write-review-modal, .jdgm-review-widget-modal')) return;
        capturePendingReviewDraft(t.closest('.jdgm-write-review-modal, .jdgm-review-widget-modal'));
      },
      true,
    );
    document.addEventListener(
      'change',
      function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        if (!t.closest('.jdgm-write-review-modal, .jdgm-review-widget-modal')) return;
        capturePendingReviewDraft(t.closest('.jdgm-write-review-modal, .jdgm-review-widget-modal'));
      },
      true,
    );
    document.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var star = t.closest(
          '.jdgm-write-review-modal .jdgm-star, .jdgm-write-review-modal .jm-star, .jdgm-review-widget-modal .jdgm-star',
        );
        if (!star) return;
        window.setTimeout(function () {
          capturePendingReviewDraft(star.closest('.jdgm-write-review-modal, .jdgm-review-widget-modal'));
        }, 50);
      },
      true,
    );
  }

  function injectOptimisticReview(draft) {
    if (!draft) return;
    var section = document.querySelector('.product-reviews--judgeme');
    if (!section) return;

    var list = ensureMandiraReviewList(section);
    if (!list) return;

    /* If Judge.me already rendered this review, don't add a second copy */
    var fp = ((draft.name || '') + '|' + (draft.body || '')).toLowerCase().replace(/\s+/g, ' ').trim();
    var exists = Array.prototype.some.call(list.children, function (row) {
      if (!isReviewRow(row)) return false;
      return reviewContentKey(row) === fp;
    });
    if (exists) {
      dedupeOwnedReviewList(list);
      syncReviewCountFromList(section, list);
      return;
    }

    var card = document.createElement('div');
    card.className = 'jdgm-rev mandira-review-card mandira-review-optimistic';
    card.setAttribute('data-mandira-optimistic', '1');
    card.setAttribute('data-score', String(draft.score || 5));

    var meta = document.createElement('div');
    meta.className = 'mandira-review-meta';
    var nameEl = document.createElement('div');
    nameEl.className = 'mandira-review-name';
    nameEl.textContent = draft.name;
    meta.appendChild(nameEl);

    var stars = document.createElement('div');
    stars.className = 'jdgm-rev__rating mandira-optimistic-stars';
    stars.setAttribute('data-score', String(draft.score || 5));
    stars.setAttribute('aria-label', (draft.score || 5) + ' stars');
    var i;
    for (i = 1; i <= 5; i++) {
      var s = document.createElement('span');
      s.className = 'mandira-star ' + (i <= (draft.score || 5) ? 'mandira-star--on' : 'mandira-star--off');
      s.setAttribute('aria-hidden', 'true');
      s.textContent = '★';
      stars.appendChild(s);
    }
    meta.appendChild(stars);

    var body = document.createElement('div');
    body.className = 'jdgm-rev__body';
    var p = document.createElement('p');
    p.textContent = draft.body;
    body.appendChild(p);

    card.appendChild(meta);
    card.appendChild(body);
    list.insertBefore(card, list.firstChild);

    section.classList.remove('product-reviews--empty');
    var empty = section.querySelector('.mandira-reviews-empty');
    if (empty) empty.remove();

    var rows = getReviewRows(section);
    section.setAttribute('data-mandira-review-count', String(rows.length));
    section.setAttribute('data-mandira-shown', String(Math.max(rows.length, 1)));
    var countEl = section.querySelector('.mandira-reviews-count');
    if (countEl) {
      countEl.textContent = rows.length + (rows.length === 1 ? ' Review' : ' Reviews');
    } else {
      reshapeSummary();
    }
    applyClientPagination(section);
    reshapeReviewItems();
  }

  function refreshReviewsAfterSubmit() {
    var section = document.querySelector('.product-reviews--judgeme');
    if (!section) return;
    if (pendingReviewDraft) injectOptimisticReview(pendingReviewDraft);

    try {
      if (window.jdgm) {
        if (typeof window.jdgm.reloadWidgets === 'function') window.jdgm.reloadWidgets();
        if (window.jdgm.customize && typeof window.jdgm.customize.reloadWidgets === 'function') {
          window.jdgm.customize.reloadWidgets();
        }
      }
    } catch (e) {
      /* ignore */
    }

    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      ensureMandiraReviewList(section);
      var list = section.querySelector('.mandira-reviews-list');
      if (list) {
        dedupeOwnedReviewList(list);
        syncReviewCountFromList(section, list);
      }
      reshapeReviewItems();
      ensureEmptyReviewCopy();
      reshapeSummary();
      if (tries >= 8) window.clearInterval(timer);
    }, 700);
  }

  function countSsrDistribution(section) {
    var dist = section.querySelector('.jdgm-ssr-rating-distribution');
    if (!dist) return 0;
    var total = 0;
    dist.querySelectorAll('li').forEach(function (li) {
      var m = (li.textContent || '').match(/(\d)\s*stars?:\s*(\d+)/i);
      if (m) total += parseInt(m[2], 10);
    });
    return total;
  }

  function ensureEmptyReviewCopy() {
    var section = document.querySelector('.product-reviews--judgeme');
    if (!section) return;

    ensureMandiraReviewList(section);
    var list = section.querySelector('.mandira-reviews-list');
    if (list) {
      dedupeOwnedReviewList(list);
      syncReviewCountFromList(section, list);
    }

    var hasReviews = getReviewRows(section).length > 0;
    if (!hasReviews) {
      hasReviews = Boolean(
        section.querySelector(
          '.jdgm-ssr-reviews__list > .jdgm-rev, .product-reviews-app .jdgm-rev, .product-reviews-app .jm-review-item',
        ),
      );
      if (hasReviews) ensureMandiraReviewList(section);
    }

    var distCount = countSsrDistribution(section);
    var lockedCount = parseInt(section.getAttribute('data-mandira-review-count') || '0', 10);
    var existing = section.querySelector('.mandira-reviews-empty');

    /* Real reviews / SSR distribution win over sticky empty_widget + metafield 0 */
    if (hasReviews || distCount > 0 || lockedCount > 0) {
      if (existing) existing.remove();
      section.classList.remove('product-reviews--empty');
      var widget =
        section.querySelector('#judgeme_product_reviews') ||
        section.querySelector('.jdgm-review-widget') ||
        section.querySelector('.jm-review-widget');
      if (widget && /empty/i.test(widget.getAttribute('data-empty-state') || '')) {
        widget.setAttribute('data-empty-state', 'with_reviews');
      }
      return;
    }

    var widget =
      section.querySelector('#judgeme_product_reviews') ||
      section.querySelector('.jdgm-review-widget') ||
      section.querySelector('.jm-review-widget');
    var emptyAttr = (widget && widget.getAttribute('data-empty-state')) || '';
    var jmEmpty = section.querySelector('.jm-no-reviews-state, .jdgm-empty-state');
    var jmCount = parseInt(section.getAttribute('data-jm-count') || '0', 10);

    /* Don't trust sticky empty_widget while Judge.me is still hydrating */
    var jmStillLoading = Date.now() < jmEmptyGraceUntil;
    var isEmpty =
      !jmStillLoading &&
      !hasReviews &&
      distCount <= 0 &&
      (Boolean(jmEmpty) || /empty/i.test(emptyAttr) || jmCount <= 0);

    if (!isEmpty) {
      if (existing) existing.remove();
      section.classList.remove('product-reviews--empty');
      return;
    }

    section.classList.add('product-reviews--empty');

    if (!existing) {
      existing = document.createElement('div');
      existing.className = 'mandira-reviews-empty';
      existing.innerHTML =
        '<div class="mandira-reviews-empty-stars" aria-hidden="true">' +
        '<span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>' +
        '</div>' +
        '<p class="mandira-reviews-empty-status">No Reviews yet</p>' +
        '<h3 class="mandira-reviews-empty-title">Be the first one to write a review</h3>' +
        '<p class="mandira-reviews-empty-copy">Share your experience with this outfit and help other shoppers make confident decisions.</p>' +
        '<div class="mandira-reviews-empty-btn-wrap">' +
        '<button type="button" class="mandira-write-review-btn mandira-reviews-empty-btn" data-mandira-write-review>Write a Review</button>' +
        '</div>';

      var heading = section.querySelector('.product-reviews-heading');
      var summary = section.querySelector('.mandira-reviews-summary');
      if (summary) summary.remove();
      if (heading) heading.insertAdjacentElement('afterend', existing);
      else section.insertBefore(existing, section.firstChild);
    }

    /* Hide native Judge.me empty chrome once ours is mounted */
    section
      .querySelectorAll(
        '.jm-no-reviews-state, .jdgm-empty-state, .jdgm-rev-widg__header, .jm-average-rating-display, .jdgm-write-rev-link, [data-testid="write-review-button"]',
      )
      .forEach(function (el) {
        if (el.closest('.mandira-reviews-empty')) return;
        if (el.classList.contains('mandira-jm-write-trigger')) return;
        if (el.getAttribute('data-mandira-jm-trigger') != null) return;
        el.style.setProperty('display', 'none', 'important');
      });
  }

  /** Product-review form only — no store follow-up, no photo/video steps */
  function configureWriteReviewFormSettings() {
    try {
      var targets = [
        window.jdgmSettings,
        window.jdgmShopSettings,
        window.jdgm && window.jdgm.settings,
      ];
      targets.forEach(function (settings) {
        if (!settings) return;
        settings.enable_review_pictures = false;
        settings.enable_review_videos = false;
        settings.request_store_review_after_product_review = false;
        settings.request_review_other_products_in_order = false;
        settings.picture_reminder_enabled = false;
      });
    } catch (e) {
      /* ignore */
    }
  }

  function isElementVisible(el) {
    if (!el || !el.getBoundingClientRect) return false;
    var style = window.getComputedStyle(el);
    if (
      style.display === 'none' ||
      style.visibility === 'hidden' ||
      style.opacity === '0' ||
      el.hasAttribute('hidden') ||
      el.getAttribute('aria-hidden') === 'true'
    ) {
      return false;
    }
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function getOpenWriteModal() {
    var nodes = document.querySelectorAll(
      '.jdgm-write-review-modal, .jdgm-review-widget-modal',
    );
    for (var i = 0; i < nodes.length; i++) {
      var modal = nodes[i];
      if (modal.getAttribute('data-mandira-write-open') === 'true') return modal;
      if (modal.classList.contains('jdgm--visible') && isElementVisible(modal)) return modal;
      if (!modal.hasAttribute('hidden') && modal.getAttribute('aria-hidden') !== 'true') {
        if (isElementVisible(modal)) return modal;
      }
    }
    return null;
  }

  function isReviewSubmitSuccess(modal) {
    if (!modal) return false;

    /* Only VISIBLE thank-you copy — never hidden pre-rendered steps */
    var headings = modal.querySelectorAll(
      'h1, h2, h3, h4, p, [class*="title"], [class*="thank"], .jm-text',
    );
    for (var j = 0; j < headings.length; j++) {
      var el = headings[j];
      if (!isElementVisible(el)) continue;
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (
        text.indexOf('thanks for your review') !== -1 ||
        text === 'review submitted!' ||
        text.indexOf('review submitted') === 0
      ) {
        return true;
      }
    }
    return false;
  }

  function scheduleCloseAfterSubmit(modal) {
    if (reviewSubmitCloseTimer) return;
    reviewSubmitPending = true;
    capturePendingReviewDraft(modal);
    if (!pendingReviewDraft) {
      try {
        pendingReviewDraft = JSON.parse(sessionStorage.getItem('mandira_pending_review') || 'null');
      } catch (e) {
        pendingReviewDraft = null;
      }
    }
    if (pendingReviewDraft) injectOptimisticReview(pendingReviewDraft);
    reviewSubmitCloseTimer = window.setTimeout(function () {
      reviewSubmitCloseTimer = null;
      reviewSubmitPending = false;
      dismissWriteReviewModal(modal || getOpenWriteModal());
      refreshReviewsAfterSubmit();
    }, 900);
  }

  function maybeAutoCloseAfterSubmit() {
    var modal = getOpenWriteModal();
    if (!modal) return;
    /* Keep our open flag so close/CSS stay in sync */
    if (modal.getAttribute('data-mandira-write-open') !== 'true') {
      modal.setAttribute('data-mandira-write-open', 'true');
      userOpenedWriteReview = true;
    }
    if (isReviewSubmitSuccess(modal)) {
      capturePendingReviewDraft(modal);
      scheduleCloseAfterSubmit(modal);
    }
  }

  function hideUnwantedWriteFormSteps() {
    configureWriteReviewFormSettings();

    var modal = getOpenWriteModal();
    if (!modal) return;
    maybeAutoCloseAfterSubmit();
    /* If thanks screen is up, don't keep poking follow-up logic */
    if (isReviewSubmitSuccess(modal)) return;

    /* Hide media upload UI inside the product review form */
    modal
      .querySelectorAll(
        '.jdgm-write-review-modal__media-upload, .jdgm-write-review-modal__media-thumbnail, [class*="media-upload"], [class*="media-field"], [data-testid*="media"], [data-testid*="picture"], [data-testid*="video"], input[type="file"]',
      )
      .forEach(function (el) {
        var block = el.closest(
          '.jdgm-write-review-modal__field, .jdgm-form__field, .jm-stack, .jm-cluster, section, div',
        );
        (block || el).style.setProperty('display', 'none', 'important');
      });

    /* Only act on VISIBLE store/media follow-up screens (JM keeps later steps in DOM) */
    var nodes = modal.querySelectorAll('h1, h2, h3, h4, p, .jm-text, [class*="title"], [class*="intro"]');
    Array.prototype.forEach.call(nodes, function (el) {
      if (!isElementVisible(el)) return;
      var t = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (!t) return;
      var isStorePrompt =
        t.indexOf('share your experience of shopping with us') !== -1 ||
        t.indexOf('we value your feedback and use it to improve') !== -1 ||
        t.indexOf('how would you rate this store') !== -1 ||
        t.indexOf('would you like to review these products') !== -1;
      var isMediaPrompt =
        t.indexOf('share a picture') !== -1 ||
        t.indexOf('share a video') !== -1 ||
        t.indexOf('share a picture or video') !== -1 ||
        t.indexOf('upload a photo') !== -1 ||
        t.indexOf('upload a video') !== -1;
      if (!isStorePrompt && !isMediaPrompt) return;

      var page =
        el.closest('[class*="page"], [class*="screen"], [class*="step"]') || el.parentElement;
      if (page) page.style.setProperty('display', 'none', 'important');

      if (storePromptSkipDone) return;
      storePromptSkipDone = true;

      /* Prefer explicit Skip / No thanks — never the X close button (that killed the popup on open) */
      var skip = null;
      var buttons = modal.querySelectorAll('button, a');
      Array.prototype.forEach.call(buttons, function (btn) {
        if (!isElementVisible(btn)) return;
        var label = (btn.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        if (
          label === 'skip' ||
          label === 'no thanks' ||
          label === 'not now' ||
          label.indexOf('skip') === 0
        ) {
          skip = skip || btn;
        }
      });
      if (skip) {
        try {
          skip.click();
        } catch (err) {
          /* ignore */
        }
      } else if (reviewSubmitPending) {
        /* After a real submit, just close instead of leaving a blank follow-up */
        scheduleCloseAfterSubmit(modal);
      }
    });
  }

  /** Kill Judge.me auto "Review Popup" (bottom toast) — never auto-open on PDP */
  function disableReviewPopupWidget() {
    configureWriteReviewFormSettings();
    try {
      var settings = window.jdgmSettings || window.jdgmShopSettings || null;
      if (settings) {
        settings.popup_widget_show_on_product_page = false;
        settings.popup_widget_show_on_home_page = false;
        settings.popup_widget_show_on_collection_page = false;
        settings.popup_widget_show_on_cart_page = false;
        settings.popup_widget_enabled = false;
        settings.popup_widget_review_count = 0;
      }
      if (window.jdgm && window.jdgm.settings) {
        window.jdgm.settings.popup_widget_show_on_product_page = false;
        window.jdgm.settings.popup_widget_enabled = false;
      }
    } catch (e) {
      /* ignore */
    }

    document
      .querySelectorAll(
        '.jdgm-popup-widget, .jdgm-popup-widget__container, [class*="jdgm-popup-widget"], #jdgm-popup-widget',
      )
      .forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
        el.setAttribute('hidden', '');
        el.setAttribute('aria-hidden', 'true');
        try {
          el.remove();
        } catch (err) {
          /* ignore */
        }
      });
  }

  function dismissWriteReviewModal(modal) {
    clearWriteOpenTimers();
    if (reviewSubmitCloseTimer) {
      window.clearTimeout(reviewSubmitCloseTimer);
      reviewSubmitCloseTimer = null;
    }
    reviewSubmitPending = false;
    writeFormOpenLock = false;
    storePromptSkipDone = false;
    userOpenedWriteReview = false;
    writeFormLockUntil = 0;
    var targets = modal
      ? [modal]
      : Array.prototype.slice.call(
          document.querySelectorAll('.jdgm-write-review-modal, .jdgm-review-widget-modal'),
        );
    targets.forEach(function (node) {
      if (!node) return;
      node.removeAttribute('data-mandira-write-open');
      node.setAttribute('hidden', '');
      node.setAttribute('aria-hidden', 'true');
      node.classList.remove('jdgm--visible', 'is-open', 'jdgm-write-review-modal--open');
      node.classList.add('jdgm--hidden');
      node.style.setProperty('display', 'none', 'important');
      node.style.setProperty('visibility', 'hidden', 'important');
      node.style.setProperty('opacity', '0', 'important');
      node.style.setProperty('pointer-events', 'none', 'important');
    });
    document.body.style.removeProperty('overflow');
    document.documentElement.style.removeProperty('overflow');
  }

  function bindWriteReviewClose() {
    if (bindWriteReviewClose._bound) return;
    bindWriteReviewClose._bound = true;

    document.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        if (!t || !t.closest) return;

        var viewMore = t.closest('.mandira-view-more');
        if (viewMore) {
          e.preventDefault();
          e.stopPropagation();
          var sec = viewMore.closest('.product-reviews--judgeme');
          if (sec) revealMoreReviews(sec);
          return;
        }

        // Our Write a Review CTA (and keep native JM empty-state working)
        var writeBtn = t.closest('[data-mandira-write-review], .mandira-write-review-btn');
        if (writeBtn) {
          e.preventDefault();
          e.stopPropagation();
          openWriteReviewForm();
          return;
        }

        var inWriteModal = t.closest('.jdgm-write-review-modal, .jdgm-review-widget-modal');
        var submitBtn =
          t.closest(
            '.jdgm-write-review-modal button[type="submit"], .jdgm-write-review-modal .jdgm-submit-rev, .jdgm-write-review-modal__btn--leave-review, .jdgm-write-review-modal [data-testid*="submit"], .jdgm-review-widget-modal button[type="submit"]',
          ) || null;
        if (!submitBtn && inWriteModal) {
          var maybeBtn = t.closest('button, [role="button"], a.jdgm-btn');
          var label = maybeBtn
            ? (maybeBtn.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase()
            : '';
          if (
            label === 'submit review' ||
            label === 'submit' ||
            label.indexOf('submit review') !== -1 ||
            label === 'submit verified review'
          ) {
            submitBtn = maybeBtn;
          }
        }
        if (submitBtn && inWriteModal) {
          /* Block double-submit from rapid re-clicks — allow this first click through */
          if (reviewSubmitLocked) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return;
          }
          pendingReviewDraft = capturePendingReviewDraft(inWriteModal) || pendingReviewDraft;
          reviewSubmitPending = true;
          /* Lock after current event so Judge.me can process this submit once */
          window.setTimeout(function () {
            reviewSubmitLocked = true;
          }, 0);
          if (reviewSubmitCloseTimer) {
            window.clearTimeout(reviewSubmitCloseTimer);
            reviewSubmitCloseTimer = null;
          }
          window.setTimeout(maybeAutoCloseAfterSubmit, 500);
          window.setTimeout(maybeAutoCloseAfterSubmit, 1200);
          window.setTimeout(maybeAutoCloseAfterSubmit, 2200);
          /* Unlock only if JM shows a validation error and form is still editable */
          window.setTimeout(function () {
            if (!isWriteFormOpen()) return;
            if (isReviewSubmitSuccess(inWriteModal)) return;
            var err = inWriteModal.querySelector(
              '[class*="error"], [aria-invalid="true"], .jdgm-form__error',
            );
            if (err) reviewSubmitLocked = false;
          }, 3000);
        }

        var closeBtn = t.closest(
          '.jdgm-write-review-modal__close-btn, .jdgm-write-review-modal__nav-btn-close, [data-testid="close-button"], button[aria-label*="lose" i], .jdgm-btn--close',
        );
        if (closeBtn && closeBtn.closest('.jdgm-write-review-modal, .jdgm-review-widget-modal')) {
          e.preventDefault();
          e.stopPropagation();
          dismissWriteReviewModal(
            closeBtn.closest('.jdgm-write-review-modal, .jdgm-review-widget-modal'),
          );
          return;
        }
        if (t.classList && t.classList.contains('jdgm-write-review-modal__overlay')) {
          e.preventDefault();
          e.stopPropagation();
          dismissWriteReviewModal(t.closest('.jdgm-write-review-modal, .jdgm-review-widget-modal'));
        }
      },
      true,
    );

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (!userOpenedWriteReview && !isWriteFormOpen()) return;
      dismissWriteReviewModal(null);
    });

    /* Hard-stop duplicate form posts to Judge.me (2nd submit only) */
    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || !form.closest) return;
        if (!form.closest('.jdgm-write-review-modal, .jdgm-review-widget-modal, .jdgm-form')) {
          return;
        }
        if (reviewSubmitLocked) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return;
        }
        reviewSubmitPending = true;
        window.setTimeout(function () {
          reviewSubmitLocked = true;
        }, 0);
        window.setTimeout(maybeAutoCloseAfterSubmit, 600);
        window.setTimeout(maybeAutoCloseAfterSubmit, 1400);
      },
      true,
    );
  }

  function brandRoots() {
    applyVars(document.documentElement);
    applyVars(document.body);
    document
      .querySelectorAll(
        '.jm-review-widget, .jdgm-review-widget, .jdgm-widget, .jdgm-write-review-modal, .jdgm-write-review-modal__container, .jdgm-write-review-modal__content, .jdgm-write-review-modal__overlay, .jdgm-write-review-modal__sections, .jm-review-item'
      )
      .forEach(function (el) {
        applyVars(el);
        scrubTeal(el);
      });
    document.querySelectorAll('[style*="108474"]').forEach(scrubTeal);
  }

  function run() {
    if (Date.now() < writeFormLockUntil || (userOpenedWriteReview && isWriteFormOpen())) {
      return;
    }
    /* Keep write popup closed unless the shopper just clicked Write a Review */
    if (!userOpenedWriteReview) {
      document.querySelectorAll('.jdgm-write-review-modal, .jdgm-review-widget-modal').forEach(function (modal) {
        if (modal.getAttribute('data-mandira-write-open') === 'true') return;
        modal.removeAttribute('data-mandira-write-open');
        modal.setAttribute('hidden', '');
        modal.setAttribute('aria-hidden', 'true');
        modal.classList.add('jdgm--hidden');
        modal.style.setProperty('display', 'none', 'important');
      });
    }
    disableReviewPopupWidget();
    if (!document.querySelector('.product-reviews--judgeme, .jdgm-widget, .jm-review-widget')) {
      return;
    }
    brandRoots();
    reshapeSummary();
    ensureDesktopSort();
    var section = document.querySelector('.product-reviews--judgeme');
    if (section) ensureMandiraReviewList(section);
    reshapeReviewItems();
    hideReviewChrome();
    hideNativeFilledChrome();
    forceStarSizes();
    restylePagination();
    hideNoise();
    ensureEmptyReviewCopy();
    ensureWriteReviewButton();
    disableReviewPopupWidget();
  }

  disableReviewPopupWidget();
  bindWriteReviewClose();
  bindReviewDraftCapture();
  /* Restore a just-submitted review if the page reloaded before JM SSR caught up */
  try {
    var stored = JSON.parse(sessionStorage.getItem('mandira_pending_review') || 'null');
    if (stored && (stored.name || stored.body)) {
      pendingReviewDraft = stored;
      window.setTimeout(function () {
        injectOptimisticReview(pendingReviewDraft);
        window.setTimeout(function () {
          try {
            sessionStorage.removeItem('mandira_pending_review');
          } catch (err) {
            /* ignore */
          }
        }, 15000);
      }, 600);
    }
  } catch (e0) {
    /* ignore */
  }
  run();
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  window.addEventListener('resize', schedule);

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      run();
    });
  }

  if (typeof MutationObserver !== 'undefined') {
    var obs = new MutationObserver(schedule);
    obs.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class'],
    });
  }

  // Keep suppressing auto Review Popup toast only (not write-review form)
  var until = Date.now() + 12000;
  var tick = window.setInterval(function () {
    disableReviewPopupWidget();
    hideUnwantedWriteFormSteps();
    if (Date.now() > until) window.clearInterval(tick);
  }, 400);

  /* While write form is open, keep media + store-review steps suppressed and auto-close after submit */
  window.setInterval(function () {
    var openModal = getOpenWriteModal();
    if (userOpenedWriteReview || openModal || reviewSubmitPending) {
      hideUnwantedWriteFormSteps();
      maybeAutoCloseAfterSubmit();
    }
  }, 400);

  // Keep trying empty-state copy for a few seconds while Judge.me mounts
  var emptyTries = 0;
  var emptyTimer = window.setInterval(function () {
    emptyTries += 1;
    ensureEmptyReviewCopy();
    if (
      document.querySelector('.mandira-reviews-empty, .mandira-empty-review-copy') ||
      emptyTries > 25
    ) {
      window.clearInterval(emptyTimer);
    }
  }, 400);

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      /* Only treat real Write controls as open intent — not summary stars */
      if (
        t.closest(
          '[data-mandira-write-review], .mandira-write-review-btn, [data-testid="write-review-button"], .jdgm-write-rev-link',
        )
      ) {
        userOpenedWriteReview = true;
        writeFormLockUntil = Date.now() + 12000;
      }
    },
    true,
  );

  /* Start closed on every PDP */
  ensureWriteModalClosed();
})();
